// Keys loaded from environment variables (.env file)
// See .env.example for required variables
const keys = {
    REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    REACT_APP_STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    REACT_APP_PROD_URL: process.env.REACT_APP_PROD_URL,
    REACT_APP_UPDATE_QUERY_LIMIT_URL: process.env.REACT_APP_UPDATE_QUERY_LIMIT_URL,
    REACT_APP_CHECK_QUERY_LIMIT_URL: process.env.REACT_APP_CHECK_QUERY_LIMIT_URL,
    REACT_APP_BILLING_PORTAL_URL: process.env.REACT_APP_BILLING_PORTAL_URL,
    REACT_APP_GET_CUSTOMER_URL: process.env.REACT_APP_GET_CUSTOMER_URL,
    REACT_APP_GET_SUBSCRIPTION_URL: process.env.REACT_APP_GET_SUBSCRIPTION_URL,
    REACT_APP_GET_PRODUCTS_URL: process.env.REACT_APP_GET_PRODUCTS_URL,
}

export default keys
